module.exports = __webpack_public_path__ + "static/img/2.6c4bb43.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/eng/2.png
// module id = xu/j
// module chunks = 0